import { error } from "jquery";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { ItemReplacedInfo } from "../messageInfo/itemReplacedInfo";
import { ItemUnavailableInfo } from "../messageInfo/itemUnavailableInfo";
import { ItemDiscontinuedInfo } from "../messageInfo/itemDiscontinuedInfo";
import { ItemNotFoundInfo } from "../messageInfo/itemNotFoundInfo";
import { Fragment, useEffect, useState } from "react";
import $ from "jquery";
export const LineEntryResponse = ({ errItem, productCode, isAdded }) => {
  const [errorItem, setErrorItem] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (errItem) {
      const newItem = { id: Date.now(), ...errItem };
      setItems((prev) => [...prev, newItem]);
      setTimeout(() => {
        setItems((prev) => prev.filter((i) => i.id !== newItem.id));
      }, 60000);
    }
  }, [errItem]);

  useEffect(() => {
    if (isAdded) {
      $("#orderToast").fadeIn(500).delay(3000).fadeOut(500);
    }
  }, [isAdded]);

  return (
    <Fragment>
      <div id="orderToast" className="toast hide mt-3" role="alert" aria-live="assertive" aria-atomic="true">
        <div className="toast-body">
          <div className="addedOrderLft">
            <i className="fa-solid fa-circle-check"></i>
          </div>
          <div className="addedOrderRft">
            <h5>{productCode} Successfully added to cart</h5>
            <p>Please enter next product code above.</p>
          </div>
        </div>
      </div>
      <TransitionGroup>
        {items.map((item) => (
          <CSSTransition key={item.id} timeout={300} classNames="fade" unmountOnExit>
            <Fragment>
              {item.type === "ITEM_ERROR" && <ItemNotFoundInfo errItem={item} />}
              {item.type === "ITEM_REPLACE" && <ItemReplacedInfo errItem={item} />}
              {item.type === "ITEM_UNAVAILABLE" && <ItemUnavailableInfo errItem={item} />}
              {item.type === "ITEM_DISCONTINUED" && <ItemDiscontinuedInfo errItem={item} />}
            </Fragment>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </Fragment>
  );
};
